module.exports = __webpack_public_path__ + "img/logo_authorize.adeaf040.svg";